import { hydrate, render } from 'react-dom'
import './index.css'
import App from './App'
import NavAppWrapper from './components/NavAppWrapper'

declare global {
  interface Window {
    navAppIndex?: number
    snapStoreStore?: any
  }
}

if (window.navAppIndex === undefined) {
  window.navAppIndex = 0
} else {
  window.navAppIndex += 1
}

const rootElement = document.querySelectorAll('.root')[window.navAppIndex]
let AppJSX = <App navAppIndex={window.navAppIndex} />
if (process.env.REACT_APP_WRAP_NAVAPP) {
  AppJSX = <NavAppWrapper>{AppJSX}</NavAppWrapper>
}
if (rootElement && rootElement.hasChildNodes()) {
  hydrate(AppJSX, rootElement)
} else {
  render(AppJSX, rootElement)
}
